import React from "react";
import {selectLengths} from "../length/lengthSlice";
import {useSelector} from "react-redux";
import LengthPanelItem from "./length/LengthPanelItem";
import EditorPanelTabContent from "./EditorPanelTabContent";

const LengthPanelTab: React.FC = () => {
	const lengths = useSelector(selectLengths);

	return (
		<>
			<EditorPanelTabContent>
				{lengths.map(length => <LengthPanelItem key={length.id} length={length}/>)}
			</EditorPanelTabContent>
		</>
	)
};

export default LengthPanelTab
